import { Outlet } from 'react-router-dom';

/**
 * Route wrapper for the /auth/* pages. Kept intentionally thin: each auth page
 * composes the @vnetwork/ui `AuthLayout` shell itself (so it can set its own
 * title/subtitle), and this just provides the routed <Outlet />.
 */
export function AuthLayout() {
  return <Outlet />;
}
